import React from "react";
import { useState } from "react";
import { getCookie, setCookie } from "../../utils/cookie";
import { getAsOfDate, isShowHomeModal } from "../../utils/functions";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import HomePopup from "../HomePopup/HomePopup";
import Modal from "../Modal";
import HealthCheckPopup from "../HealthCheckPopup/HealthCheckPopup";
import { useEffect } from "react";
import { observer } from "mobx-react";

const HomeModals = () => {
  const [showPopup, setShowPopup] = useState(
    getCookie("showpopup") === "1" &&
      isShowHomeModal(UserStore.asOfDate) &&
      UserStore.asOfDate
  );
  const [isHealthCheckPopup, setIsHealthCheckPopup] = useState(
    AuthStore.healthCheckData === "1"
  );

  useEffect(() => {
    if (showPopup && showPopup != "0") setCookie("showpopup", "0");
  }, [showPopup]);

  const as_of_date = getAsOfDate(UserStore.asOfDate);

  useEffect(() => {
    if (UserStore.asOfDate && getCookie("showpopup") === "1") {
      isShowHomeModal(UserStore.asOfDate) && setShowPopup(true);
      setCookie("showpopup", "0");
    }
  }, [as_of_date]);

  return (
    <div>
      <Modal
        modalStyle={{
          padding: "25px 25px 33px",
        }}
        showCloseIcon={true}
        open={showPopup}
        onClose={() => {
          setShowPopup(false);
        }}
      >
        <HomePopup
          onClick={() => {
            setShowPopup(false);
          }}
        />
      </Modal>
      <Modal
        modalStyle={{
          padding: "25px 25px 33px",
        }}
        showCloseIcon={true}
        open={isHealthCheckPopup}
        onClose={() => {
          setIsHealthCheckPopup(false);
          AuthStore.updatehealthCheckData("0");
          isShowHomeModal(UserStore.asOfDate) && setShowPopup(true);
        }}
      >
        <HealthCheckPopup
          onClick={() => {
            setIsHealthCheckPopup(false);
            AuthStore.updatehealthCheckData("0");
            isShowHomeModal(UserStore.asOfDate) && setShowPopup(true);
          }}
        />
      </Modal>
    </div>
  );
};

export default observer(HomeModals);
